import { Component, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { JourneySearchStore } from "src/app/features/store/journey-search-store";
import { Button } from "src/app/shared/components/utils/button/button";
import { Icon } from "src/app/shared/components/utils/icon/icon";

interface JourneyPages {
  title: string;
  route: string;
  progressPercentage: string;
}

export const matureJourney: JourneyPages[] = [
  {
    title: "breadcrumb.clarifyProject",
    route: "journey/clarify",
    progressPercentage: "20%",
  },
  {
    title: "breadcrumb.languageTest",
    route: "journey/language-test",
    progressPercentage: "40%",
  },
  {
    title: "breadcrumb.mobilityRef",
    route: "journey/mobility-ref",
    progressPercentage: "60%",
  },
  {
    title: "breadcrumb.offers",
    route: "journey/offers",
    progressPercentage: "80%",
  },
  {
    title: "breadcrumb.hrContact",
    route: "journey/hr-contact",
    progressPercentage: "100%",
  },
];

export const immatureJourney: JourneyPages[] = [
  {
    title: "breadcrumb.clarifyProject",
    route: "journey/clarify",
    progressPercentage: "50%",
  },
  {
    title: "breadcrumb.hrContact",
    route: "journey/hr-contact",
    progressPercentage: "100%",
  },
];

@Component({
  selector: "app-journey-breadcrumb",
  imports: [Icon, Button, TranslocoModule],
  templateUrl: "./journey-breadcrumb.html",
})
export class JourneyBreadcrumb {
  store = inject(JourneySearchStore);
  isJourneyImmature = computed(() => this.store.isJourneyImmature());
  private readonly router = inject(Router);
  currentJourney = computed(() => {
    return this.isJourneyImmature() ? immatureJourney : matureJourney;
  });

  redirectTo(route: string) {
    this.router.navigate([route]);
  }

  isTheCurrentPage(route: string): boolean {
    return this.router.url.includes(route);
  }

  isTheLastPage(): boolean {
    const currentRoute = this.router.url;
    const lastPageRoute = this.currentJourney().slice(-1)[0].route;
    if (currentRoute.includes(lastPageRoute)) {
      return true;
    } else {
      return false;
    }
  }

  isTheFirstPage(): boolean {
    const currentRoute = this.router.url;
    const firstPageRoute = this.currentJourney()[0].route;
    if (currentRoute.includes(firstPageRoute)) {
      return true;
    } else {
      return false;
    }
  }

  goToNextStep() {
    const currentRoute = this.router.url;
    const currentIndex = this.currentJourney().findIndex((page) =>
      currentRoute.includes(page.route)
    );
    if (currentIndex < this.currentJourney().length - 1) {
      const nextPageRoute = this.currentJourney()[currentIndex + 1].route;
      this.router.navigate([nextPageRoute]);
    }
  }

  goToPreviousStep() {
    const currentRoute = this.router.url;
    const currentIndex = this.currentJourney().findIndex((page) =>
      currentRoute.includes(page.route)
    );
    if (currentIndex > 0) {
      const previousPageRoute = this.currentJourney()[currentIndex - 1].route;
      this.router.navigate([previousPageRoute]);
    } else {
      this.router.navigate(["journey/search"]);
    }
  }
}
